import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useCreateNewContact = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onCreateNewContactError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while creating new contact.',
        );
    };

    const onCreateNewContactSuccess = (callback: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        callback();
    };

    const createNewContact = (data: any, callback: () => void) => {
        const url: HttpConfig = {
            url: `api/v1/contacts`,
            method: 'post',
            data: data
        };

        request(url, onCreateNewContactSuccess(callback), setLoading, onCreateNewContactError);
    };

    return { createNewContact, loading };
};

export default useCreateNewContact;
